import axios from 'axios';
import {environment} from './src/environment/environment';

class InitSharedRepo {
  // Call at the very beginning
  static init() : void {
    axios.defaults.timeout = environment.reqTimeout;
    axios.defaults.headers.common['Content-Type'] = 'application/json';
    axios.defaults.baseURL = environment.baseUrl;
  }

  // Call after authentication is done and make required changes
  static initAfterAuth(token: string) : void {
    axios.defaults.headers.common['authorization'] = 'Bearer' + ' ' + token;
  }
  static initAfterPatientAuth(token: string) : void {
    axios.defaults.headers.common['authorization'] = 'Bearer' + ' ' + token;
  }
  static removeAuthorization() : void{
    axios.defaults.headers.common['authorization'] = null
  }
}

export default InitSharedRepo;
